import type { FunctionComponent } from 'react'

import { H2 } from '@monthio/design-system'
import {
	DebtOverviewIntroExplainerIcon1,
	DebtOverviewIntroExplainerIcon2,
} from '@monthio/icons'
import { useTranslation } from 'react-i18next'

import {
	ExplainerList,
	ExplainerListItem,
} from '../../../modulesTemp/general/FlowWizardUtils'

export const DebtOverviewIntro: FunctionComponent = () => {
	const { t } = useTranslation()
	return (
		<div>
			<H2>{t('debtOverview-intro-explainer-header')}</H2>
			<ExplainerList>
				<ExplainerListItem>
					<DebtOverviewIntroExplainerIcon1 width={24} height={24} />
					{t('debtOverview-intro-explainer-1')}
				</ExplainerListItem>
				<ExplainerListItem>
					<DebtOverviewIntroExplainerIcon2 width={24} height={24} />
					{t('debtOverview-intro-explainer-2')}
				</ExplainerListItem>
			</ExplainerList>
		</div>
	)
}
